import { UrlConstants } from "../../../../utils/ApiConstants";
import axios from "axios";
import { authHeader } from "../../../../utils/utils";
import { Notification } from "../../../../components/notification/notification";
import { replaceWithCurrentApiVersion } from "../../../../utils/api";

const fieldsToSkipInPayload = ["loanNo", "receiptAmount"];

export const markReceiptCancelVerificationStatus: any = async (recordId: string, endpoint: string, payload:any, message: string) => {

  endpoint = endpoint?.replace("{recordId}", recordId);
  try {
      let requestBody = JSON.parse(JSON.stringify(payload));
      fieldsToSkipInPayload.forEach(skipField => {
        if(requestBody[skipField]){
          delete requestBody[skipField];
        }
      });
      const { status } = await axios.put(`${UrlConstants.BASE_URL}${replaceWithCurrentApiVersion(endpoint)}`, requestBody, {
          headers: {
              authorization: `${authHeader().Authorization}`,
              "Access-Control-Allow-Origin": "*",
          }
      });
      if (status !== 200 && status !== 201) {
          Notification("error", "Transaction failed! ");
          return {message:"Failed to perform the operation: ", status:"ERROR"};
      } else {
                  Notification("success", message);
          return {message: message, status:"SUCCESS"};
      }
  } catch (err: any) {
          Notification("error", "Something went wrong, please check with admin.");
      return {message:"Something went wrong, please check with admin.", status:"ERROR"};
  }
}


export const markReceiptCancellationAsVerified: any = (recordId:  string, data:any, args: any[]) => {
  return markReceiptCancelVerificationStatus(recordId, args[0], data, "Successfully marked as verified.");
}

export const markReceiptCancellationAsRejected: any = (recordId:  string, data:any, args: any[]) => {
  return markReceiptCancelVerificationStatus(recordId, args[0], data, "Successfully rejected the cancel request.");
}